import { render, staticRenderFns } from "./FixDispatchBatches.vue?vue&type=template&id=4ce8fa31"
import script from "./FixDispatchBatches.vue?vue&type=script&lang=ts"
export * from "./FixDispatchBatches.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports